import { render, staticRenderFns } from "./ArticleSidebarRight.vue?vue&type=template&id=b53dc2c0&scoped=true&"
import script from "./ArticleSidebarRight.vue?vue&type=script&lang=js&"
export * from "./ArticleSidebarRight.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSidebarRight.vue?vue&type=style&index=0&id=b53dc2c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53dc2c0",
  null
  
)

export default component.exports